import { TruckService, UnitOfMeasureService } from '@general/proxy/general/controllers';
import { FieldDefinition, FieldBuilder, MENU_CATEGORY_KEY, MENU_NAME_SUFFIX, MENU_SUBCATEGORY_KEY, MenuCategories, MenuSubcategories } from '@zendra/shared';

FieldBuilder.setNamespace('General');

export const NURSERYTRUCKPARAMETER_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .number('capacity', 'Entity.NurseryTruckParameter.Capacity')
    .required()
    .build(),
  FieldBuilder
    .foreignKey('unitOfMeasureId', 'Entity.UnitOfMeasure', UnitOfMeasureService)
    .required()
    .displayFromNested('unitOfMeasure.name')
    .sortBy('unitOfMeasure.name')
    .build(),
  FieldBuilder
    .foreignKey('truckId', 'Entity.Truck', TruckService)
    .required()
    .displayFromNested('truck.name')
    .sortBy('truck.name')
    .hideInChildForms()
    .build(),
];

export const NURSERYTRUCKPARAMETER_CONFIG = {
  entityName: 'NurseryTruckParameter',
  localizationKey: 'General::Entity.NurseryTruckParameter',
  fields: NURSERYTRUCKPARAMETER_FIELDS,
  permission: 'GeneralMachinesAndVehicles.NurseryTruckParameters',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.General + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.MachinesAndVehicles + MENU_NAME_SUFFIX,
};
